import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function ScrollToTopButton() {
  // Get scroll progress (0 to 1)
  const { scrollYProgress } = useScroll();

  // Define circle parameters
  const radius = 24;
  const circumference = 2 * Math.PI * radius;

  // Map scroll progress to the strokeDashoffset: when scrolled to bottom (1) the circle is fully filled (offset=0)
  const dashOffset = useTransform(scrollYProgress, [0, 1], [circumference, 0]);

  // Smooth scroll to top on click
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.div
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.9 }}

      onClick={handleClick}
      className="fixed bg-gray-200/50 rounded-full md:bottom-10 bottom-6 right-5 md:right-10 z-40 cursor-pointer"
    >
      <svg width="50" height="50" viewBox="0 0 60 60">
        {/* Animated circle stroke */}
        <motion.circle
          cx="30"
          cy="30"
          r={radius}
className="stroke-prime-200"          strokeWidth="4"
          fill="none"
          
        />
        <motion.circle
          cx="30"
          cy="30"
          r={radius}
          stroke="#417dcf"
          strokeWidth="4"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
        />
   
        {/* Upward arrow */}
        <motion.path
          d="M30 20 L30 38 M30 20 L22 28 M30 20 L38 28"
          stroke="#417dcf"
          strokeWidth="3.7"
          fill="none"
          strokeLinecap="square"
        />


      </svg>
    </motion.div>
  );
}
